import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { userConfigStore } from "@/store/user-config-store";
import { useTranslation } from "react-i18next";

export function PhonebookSection() {
  const { t } = useTranslation("user-settings");
  const phonebookFiltersVisible = userConfigStore((state) => state.phonebookFiltersVisible);
  const setPhonebookFiltersVisible = userConfigStore((state) => state.setPhonebookFiltersVisible);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Tables")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4">
          <div className="space-y-1">
            <Label className="text-sm font-medium">{t("ShowFiltersByDefault")}</Label>
            <p className="text-muted-foreground text-xs">{t("ShowFiltersByDefaultDescription")}</p>
          </div>
          <Switch checked={phonebookFiltersVisible} onCheckedChange={setPhonebookFiltersVisible} />
        </div>
      </CardContent>
    </Card>
  );
}
